import fetch from "cross-fetch";
import { AttributeTypes, LocaleTypes, RequestTypes } from "@iddataweb/idw-common-ui/enums";
import { Logger } from "@utils/logger";
import { getAttributeSubmitValue } from "@utils/attribute-data-util";
import { AttributeFormState } from "../types/state/attribute-form-state";
import { AttributeStatusTypes } from "../enums/attribute-status-types";

export const getVerifyRequestData = (attributeFormStates: Array<AttributeFormState>, verifyToken: string, asi: string, activeLanguage: LocaleTypes) => {
    let attributeVerifyRequestData: Array<{
        id: number;
        attributeType: AttributeTypes;
        status: AttributeStatusTypes;
        data: {
            [key: string]: string | number;
        };
    }> = [];

    if (attributeFormStates) {
        attributeVerifyRequestData = attributeFormStates.map(afs => {
            const submitValue = getAttributeSubmitValue(afs);

            Logger.info(
                `Attribute ${afs.type} has status -${afs.status}- /submit data: ${submitValue}`,
                {
                    type: afs.type,
                    status: afs.status,
                    submitValue: submitValue
                }
            );

            return submitValue;
        });
    }

    const verifyRequest = {
        verifyToken,
        verifyRequestData: { asi, postData: attributeVerifyRequestData },
        language: activeLanguage
    };
    Logger.info('request data to be sent', verifyRequest);
    return verifyRequest;
};

export const submitVerificationData = async (
    verifyRequestData: any,
    verifyURL: string,
    // requestCounter: number
): Promise<Response> => {
    const request = {
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(verifyRequestData),
        method: RequestTypes.POST
    };

    return await fetch(verifyURL, request);
    // if (requestCounter > 0) {
    //     return await fetch("http://localhost:3001/verifypin");
    // } else {
    //     return await fetch("http://localhost:3001/verify");
    // }
};